import { Box, Button, Drawer, Stack, Tooltip, Typography } from '@mui/material'
import { Component } from 'react'
import '../pharmaReports.css';
import { Colors } from '../../../../Styles/Colors';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DataGrid } from '@mui/x-data-grid';
import { CommonGridToolBarWithFilterText } from '../../../../Components/Common Components/CommonComponents';
// import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import { withTranslation } from 'react-i18next';
import PharmaFilter from '../PharmaFilter';
// import { DateTime } from 'luxon';
import { AmountFormat } from '../../../../Components/CommonFunctions/CommonFunctions';
import { CurrencySymbol } from '../../../../Utility/Constants';

class MISReport extends Component {

    constructor(props) {
        super(props)
        this.state = {
            misReportData: [],
            page: 0,
            pageSize: 10,
            rowCount: 0,
            filterDatas: {
                // 'fromDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                // 'toDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                // "dateIndex": 1,
                'brandName': '',
                'genericName': '',
                'vendorOne': '',
                'vendorTwo': '',
                'vendorThree': '',
                "dosageType": [],
            },
            pageName: 'MISReport',
            filterOpen: false,
        }
    }

    LoaderFunction = (key) => {
        this.setState({
          isLoader: key
        })
      }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message,
            disableBtn: false
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    renderFilter = (data) => {
        this.setState({
            filterDatas: data,
            filterOpen: false,
            page: 0,
        }, () => { this.getMISReportData() })
    }

    ClosePopUp() {
        this.setState({
            filterOpen: false,
        })
    }

    clearFilter = (data) => {
        this.setState({
            filterDatas: data
        })
    }

    gridToolBar = () => {
        let TextArray = [
            // { label: "From Date", value: formatDate(this.state.filterDatas.fromDate) },
            // { label: "To Date", value: formatDate(this.state.filterDatas.toDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} noExport={true} />
            </Box>

        )
    }

    getMISReportData = () => {
        try {
            this.LoaderFunction(true)
            let vendor1 = this.state.filterDatas?.vendorOne?.vendor_id ? this.state.filterDatas?.vendorOne?.vendor_id : ''
            let vendor2 = this.state.filterDatas?.vendorTwo?.vendor_id ? this.state.filterDatas?.vendorTwo?.vendor_id : ''
            let vendor3 = this.state.filterDatas?.vendorThree?.vendor_id ? this.state.filterDatas?.vendorThree?.vendor_id : ''
            let brandName = this.state.filterDatas.brandName?.replaceAll('&','%26')
            RestAPIService.getAll(Serviceurls.PHARMA_INVENTORY_MIS_REPORT_GET + `?vendor1=${vendor1}&vendor2=${vendor2}&vendor3=${vendor3}&page=${this.state.page + 1}&page_size=${this.state.pageSize}&brand_name=${brandName}&generic_name=${this.state.filterDatas.genericName}&dosage_type=${this.state.filterDatas.dosageType}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            misReportData: response?.data?.data?.result,
                            rowCount: response.data.data?.total_count
                        }, ()=>{ this.LoaderFunction(false) })
                    }
                }).catch((error) => {
                    this.setState({
                        misReportData: [],
                        rowCount: 0,
                    })
                    if (error?.response?.data?.message) {
                        this.LoaderFunction(false)
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.LoaderFunction(false)
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getMISReportExcel = () => {
        try {
            let vendor1 = this.state.filterDatas?.vendorOne?.vendor_id ? this.state.filterDatas?.vendorOne?.vendor_id : ''
            let vendor2 = this.state.filterDatas?.vendorTwo?.vendor_id ? this.state.filterDatas?.vendorTwo?.vendor_id : ''
            let vendor3 = this.state.filterDatas?.vendorThree?.vendor_id ? this.state.filterDatas?.vendorThree?.vendor_id : ''
            let brandName = this.state.filterDatas.brandName?.replaceAll('&', '%26')
            if (vendor2 && !vendor1) {
                this.errorMessage("Vendor One is required if Vendor Two is selected");
                return;
            }
            if (vendor3 && (!vendor1 || !vendor2)) {
                this.errorMessage("Vendor One and Vendor Two are required if Vendor Three is selected");
                return;
            }
            this.setState({disableBtn: true})
            RestAPIService.excelGet(Serviceurls.PHARMA_INVENTORY_MIS_REPORT_GET + `?vendor1=${vendor1}&vendor2=${vendor2}&vendor3=${vendor3}&page=${this.state.page + 1}&page_size=${this.state.pageSize}&brand_name=${brandName}&generic_name=${this.state.filterDatas.genericName}&dosage_type=${this.state.filterDatas.dosageType}&export=excel`).
                then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data; //here we load our csv data 

                        let filename = response.headers["content-disposition"].split("filename=")[1]
                        // var blob = new Blob([csvContent], {type: 'data:application/vnd.ms-excel;base64'});

                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                        pom.click();
                        this.setState({disableBtn: false})
                    }
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        this.errorMessage(error.response?.data?.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                    this.setState({disableBtn: false})
                })
        } catch (error) {
            this.errorMessage(error.message);
            this.setState({disableBtn: false})
        }
    }
     
    MISReportPrint = () => {
        try {
            this.setState({disabled: true})
            let vendor1 = this.state.filterDatas?.vendorOne?.vendor_id ? this.state.filterDatas?.vendorOne?.vendor_id : ''
            let vendor2 = this.state.filterDatas?.vendorTwo?.vendor_id ? this.state.filterDatas?.vendorTwo?.vendor_id : ''
            let vendor3 = this.state.filterDatas?.vendorThree?.vendor_id ? this.state.filterDatas?.vendorThree?.vendor_id : ''
            let brandName = this.state.filterDatas.brandName?.replaceAll('&','%26')
            RestAPIService.getAll(Serviceurls.PHARMA_INVENTORY_MIS_REPORT_GET + `?vendor1=${vendor1}&vendor2=${vendor2}&vendor3=${vendor3}&page=${this.state.page + 1}&page_size=${this.state.pageSize}&brand_name=${brandName}&generic_name=${this.state.filterDatas.genericName}&dosage_type=${this.state.filterDatas.dosageType}&export=pdf`)
            .then((response) => {
              const file = new Blob(
                [response.data],
                { type: 'application/pdf' });
              const fileURL = URL.createObjectURL(file);
              window.open(fileURL);
              this.setState({disabled:false})
            }).catch((error) => {
              if(error?.response?.data?.message){
                this.errorMessage(error?.response?.data?.message)
              }else{
                this.errorMessage(error.message)
              }
              this.setState({disabled:false})
            })
        } catch (error) {
          this.errorMessage(error.message)
          this.setState({disabled:false})
        }
      }

    render() {
        const { t } = this.props
        this.state.misReportData.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'brand_name', headerName: "Brand Name", flex: 0.167,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.brand_name?.length > 12 ? <Tooltip placement='top' title={params?.row?.brand_name} arrow><div>{params?.row?.brand_name?.slice(0, 12) + '...'}</div></Tooltip> :
                        params?.row?.brand_name ? params?.row?.brand_name : '-'}
                </Box>)
            },
            {
                field: 'generic_name', headerName: "Generic Name", flex: 0.167,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.generic_name?.length > 12 ? <Tooltip placement='top' title={params?.row?.generic_name} arrow><div>{params?.row?.generic_name?.slice(0, 12) + '...'}</div></Tooltip> :
                        params?.row?.generic_name ? params?.row?.generic_name : '-'}
                </Box>)
            },
            {
                field: 'dosage_type', headerName: "Dosage Type", flex: 0.167,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.dosage_type?.length > 12 ? <Tooltip placement='top' title={params?.row?.dosage_type} arrow><div>{params?.row?.dosage_type?.slice(0, 12) + '...'}</div></Tooltip> :
                        params?.row?.dosage_type ? params?.row?.dosage_type : '-'}
                </Box>)
            },
            {
                field: 'dosage_strength', headerName: "Dosage Strength", flex: 0.167, headerAlign: 'center', align: 'center',
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.dosage_strength?.length > 12 ? <Tooltip placement='top' title={params?.row?.dosage_strength} arrow><div>{params?.row?.dosage_strength?.slice(0, 12) + '...'}</div></Tooltip> :
                        params?.row?.dosage_strength ? params?.row?.dosage_strength : '-'}
                </Box>)
            },
            {
                field: 'vendor1', flex: 0.167,
                renderHeader: (params) => (<Box component={'div'}>
                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{this.state.filterDatas?.vendorOne?.vendor_name ? this.state.filterDatas?.vendorOne?.vendor_name : 'Vendor One'}</Typography>
                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Price/Pack'}</Typography>
                </Box>),
                renderCell: (params) => (<Box component={'div'}>{AmountFormat(params.row?.vendor1 != "-" ? params.row?.vendor1 : 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
            },
            {
                field: 'vendor2', flex: 0.167,
                renderHeader: (params) => (<Box component={'div'}>
                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{this.state.filterDatas?.vendorTwo?.vendor_name ? this.state.filterDatas?.vendorTwo?.vendor_name : 'Vendor Two'}</Typography>
                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Price/Pack'}</Typography>
                </Box>),
                renderCell: (params) => (<Box component={'div'}>{AmountFormat(params.row?.vendor2 != "-" ? params.row?.vendor2 : 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
            },
            {
                field: 'vendor3', flex: 0.167,
                renderHeader: (params) => (<Box component={'div'}>
                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{this.state.filterDatas?.vendorThree?.vendor_name ? this.state.filterDatas?.vendorThree?.vendor_name : 'Vendor Three'}</Typography>
                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Price/Pack'}</Typography>
                </Box>),
                renderCell: (params) => (<Box component={'div'}>{AmountFormat(params.row?.vendor3 != "-" ? params.row?.vendor3 : 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
            }
        ]
        const disablePrintExcel = this.state.disabled || this.state.misReportData?.length === 0;
        return (
            <Box component={'div'} height={'80vh'} sx={{ backgroundColor: Colors.Background }}>
                <Box component={'div'} className='eMed_Pharma_rts_header' sx={{ height : "7vh"}}>
                    <Box component={'div'} flex={0.8} display={'flex'}>

                    </Box>
                    <Box flex={0.2} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} marginRight={'0.5vw'}>
                        <Button emed_tid = "rpt_mis_flt" className='eMed_Pharma_rts_btn' onClick={() => this.setState({ filterOpen: true })}>
                            <Box component={'img'} src={ImagePaths.Filter.default} alt='filter' className='eMed_action_img' />
                        </Button>
                        <Button className='eMed_Pharma_rts_btn' disabled={disablePrintExcel} onClick={() => this.MISReportPrint()}>
                            <Box component={'img'} src={disablePrintExcel ? ImagePaths.PrintIconOff.default : ImagePaths.LabPrintIcon.default} alt='print' className='eMed_action_img'  />
                        </Button>
                        <Button emed_tid = "rpt_mis_export" className='eMed_Pharma_rts_btn' disabled={disablePrintExcel} onClick={() => this.getMISReportExcel()}>
                            <Box component={'img'} src={disablePrintExcel ? ImagePaths.ExportIconOff.default : ImagePaths.ExportIcon.default} alt='export' className='eMed_action_img' />
                        </Button>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_Pharma_rts_tbl_card' sx={{ height : "72vh"}}>
                    <DataGrid
                        className='eMed_Pharma_table'
                        rows={this.state.misReportData}
                        columns={columns}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        getRowId={(row) => row['sno']}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        rowCount={this.state.rowCount}
                        onPageChange={(newPage) => { this.setState({ page: newPage }, () => this.getMISReportData()) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize }, () => this.getMISReportData())}
                        rowsPerPageOptions={[10, 20, 30]}
                        headerHeight={50}
                        disableSelectionOnClick
                        pagination
                        paginationMode='server'
                        loading={this.state.isLoader}
                    />
                </Box>

                <Drawer
                    anchor={'right'}
                    open={this.state.filterOpen}
                    ModalProps={{ onBackdropClick: this.ClosePopUp.bind(this) }}
                >
                    <PharmaFilter pageName={this.state.pageName} filterDatas={this.state.filterDatas} closeFilter={this.ClosePopUp.bind(this)} filteredData={this.renderFilter.bind(this)} ClearData={this.clearFilter.bind(this)} calDosType={true}/>
                </Drawer>

                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}

export default withTranslation()(MISReport)